import { DateField, Labeled, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const BasicInfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        title="Основна информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Специалност (БГ)">
            <TextField source="specializationNameBg" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Специалност (EN)">
            <TextField source="specializationNameEn" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Тип">
            <TextField source="specializationTypeName" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Валиден от">
            <DateField
              source="validFrom"
              locales="bg-BG"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default BasicInfoSection;
